import { FormattedMessage } from 'react-intl';
import Text from '../../components/Text';
import Box from '../../components/layout/Box';
import Image from '../../components/Image';

const MenuHeader = ({ isOpen }) => {
  return (
    <Box
      className="align-items-center"
      style={{
        height: 64,
        paddingLeft: 8,
        paddingRight: 8,
      }}
    >
      <Box style={{ width: 42 }} className="justify-content-center">
        <Image
          style={{ width: 32, height: 'auto' }}
          source="https://kthbok-images.s3.eu-north-1.amazonaws.com/content/white-green-logo-small.png"
        />
      </Box>
      {isOpen && (
        <Box className="flex-column" style={{ marginLeft: 8 }}>
          <Text variant="logoText">
            <FormattedMessage defaultMessage="KTHBOK" />
          </Text>

          <Text variant="logoSlogan">
            <FormattedMessage defaultMessage="Begagnad kursliteratur på campus" />
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default MenuHeader;
